import {Box, Grid, makeStyles, TextareaAutosize, Typography} from "@material-ui/core";
import React, {useContext, useState} from "react";
import {ThemeContext} from "../../../utils/themeContext";
import {useTranslation} from "react-i18next";
import {AppContext} from "../../../utils/appContext";

export const InputMessage = () => {

    const appContext = useContext(AppContext);
    const theme = useContext(ThemeContext);
    const {t} = useTranslation();

    const useStyles = makeStyles({
        textarea: {
            border: 0,
            boxShadow: '0px 3px 10px #00000029!important',
            borderRadius: 0,
            width: '100%',
            padding: 10,
            height: '140px!important',
            fontFamily: 'Poppins',
            [theme.breakpoints.down('sm')]: {
                padding: 10,
            }
        },
    });

    const classes = useStyles();

    const handleNotes = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        appContext.helpForm['Note'] = event.target.value;
        appContext.setHelpForm({...appContext.helpForm});
    };

    return (
        <Grid item xs={12}>

            <Box mt={3} mb={3}>
                <Typography variant={"h5"}>{t('raccontaci_come_aiutarti')}</Typography>
            </Box>

            <Typography variant={'h6'} component={'h6'} style={{ marginBottom: '8px' }}>{t('Scrivi qui il tuo messaggio')}*</Typography>
            <TextareaAutosize
                className={classes.textarea}
                aria-label="minimum height"
                minRows={5}
                placeholder={t('placeholder_note_helpform')}
                value={appContext.helpForm.Note}
                onChange={handleNotes}
                name={'Note'}
            />
        </Grid>
    )
};
